// Copyright (c) 2015-present Mattermost, Inc. All Rights Reserved.
// See LICENSE.txt for license information.

import React from 'react';

type SvgProps = {
    width?: number;
    height?: number;
}

const MobileSecuritySVG = (props: SvgProps) => (
    <svg
        width={props.width ? props.width.toString() : '208'}
        height={props.height ? props.height.toString() : '120'}
        viewBox='0 0 208 120'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
    >
        <rect
            x='10.7451'
            y='22'
            width='181'
            height='78'
            rx='5.625'
            fill='#1C58D9'
            fillOpacity='0.12'
        />
        <path
            d='M12 28L17.5 33.5V72.5H182.5V101.5'
            stroke='#3F4350'
            strokeOpacity='0.24'
            strokeLinecap='round'
        />
        <circle
            cx='2.5'
            cy='2.5'
            r='2.5'
            transform='matrix(1 0 0 -1 180 105)'
            fill='#3F4350'
            fillOpacity='0.48'
        />
        <circle
            cx='2.5'
            cy='2.5'
            r='2.5'
            transform='matrix(1 0 0 -1 8 36)'
            fill='#3F4350'
            fillOpacity='0.48'
        />
        <ellipse
            cx='102.5'
            cy='60.5'
            rx='59.5'
            ry='59.5'
            fill='#1C58D9'
            fillOpacity='0.04'
        />
        <path
            d='M50 41L50 49.7097L148.46 49.7097L148.46 59L163 59'
            stroke='#3F4350'
            strokeOpacity='0.24'
            strokeLinecap='round'
        />
        <path
            d='M136 100L136 85L121 85'
            stroke='#3F4350'
            strokeOpacity='0.24'
            strokeLinecap='round'
        />
        <ellipse
            cx='1.5'
            cy='1.5'
            rx='1.5'
            ry='1.5'
            transform='matrix(1 8.74228e-08 8.74228e-08 -1 48.5 42)'
            fill='#3F4350'
            fillOpacity='0.48'
        />
        <ellipse
            cx='136'
            cy='101.5'
            rx='1.5'
            ry='1.5'
            transform='rotate(180 136 101.5)'
            fill='#3F4350'
            fillOpacity='0.48'
        />
        <ellipse
            cx='1.5'
            cy='1.5'
            rx='1.5'
            ry='1.5'
            transform='matrix(1 8.74228e-08 8.74228e-08 -1 162 70)'
            fill='#3F4350'
            fillOpacity='0.48'
        />
        <path
            d='M102.238 107.436L102.482 107.572L102.725 107.437L107.738 104.652L107.738 104.652C134.208 89.9349 140.141 62.6051 142.498 32.2629L142.533 31.8248L142.102 31.7348L141.977 31.7086L141.927 31.698H141.875C129.258 31.698 116.365 27.1582 102.822 14.6329L102.444 14.2833L102.105 14.6715C96.4271 21.1871 91.4818 25.1561 85.8022 27.6605C80.114 30.1687 73.6481 31.2268 64.8879 31.85L64.8664 31.8515L64.8451 31.8549L62.9217 32.1596L62.4635 32.2323L62.5017 32.6946C64.9873 62.7953 70.8178 89.8754 97.0623 104.543L102.238 107.436Z'
            fill='white'
            stroke='#3F4350'
        />
        <path
            d='M70.2469 81.6538C73.544 87.9479 77.7115 93.688 83.0142 98.7308M84.5619 100.154C85.6612 101.131 86.8066 102.08 88 103'
            stroke='#3F4350'
            strokeLinecap='round'
            strokeLinejoin='round'
        />
        <path
            d='M102.485 99L98.0951 96.6096C76.045 84.6062 71.1078 62.4456 69 37.5833L70.6312 37.3316C85.5165 36.3001 92.8039 33.8204 102.485 23C114.04 33.4089 125.074 37.207 135.894 37.207L136 37.2287C134.001 62.2886 128.977 84.6549 106.736 96.6989L102.485 99Z'
            fill='#3F4350'
            fillOpacity='0.12'
        />
        <path
            d='M77.5632 51.6124H121.686'
            stroke='#3F4350'
            strokeOpacity='0.12'
            strokeLinecap='round'
        />
        <path
            d='M84.1345 57.2451H128.257'
            stroke='#3F4350'
            strokeOpacity='0.12'
            strokeLinecap='round'
        />
        <path
            d='M79.4407 63.8165H123.563'
            stroke='#3F4350'
            strokeOpacity='0.12'
            strokeLinecap='round'
        />
        <path
            d='M87.8896 75.0818H108.543'
            stroke='#3F4350'
            strokeOpacity='0.12'
            strokeLinecap='round'
        />
        <path
            d='M73.8076 46.1042H87.8893'
            stroke='#3F4350'
            strokeOpacity='0.12'
            strokeLinecap='round'
        />
        <path
            d='M90.7056 46.1042H111.359'
            stroke='#3F4350'
            strokeOpacity='0.12'
            strokeLinecap='round'
        />
        <path
            d='M114.175 46.1042H132.012'
            stroke='#3F4350'
            strokeOpacity='0.12'
            strokeLinecap='round'
        />
        <path
            d='M101.033 80.7149H118.869'
            stroke='#3F4350'
            strokeOpacity='0.12'
            strokeLinecap='round'
        />
        <path
            d='M87.8899 80.7149H98.2164'
            stroke='#3F4350'
            strokeOpacity='0.12'
            strokeLinecap='round'
        />
        <path
            d='M81.3184 69.1778H101.971'
            stroke='#3F4350'
            strokeOpacity='0.12'
            strokeLinecap='round'
        />
        <path
            d='M104.788 69.1777H122.624'
            stroke='#3F4350'
            strokeOpacity='0.12'
            strokeLinecap='round'
        />
        <path
            d='M77.563 40.8164H101.032'
            stroke='#3F4350'
            strokeOpacity='0.12'
            strokeLinecap='round'
        />
        <path
            d='M104.788 40.8164H128.257'
            stroke='#3F4350'
            strokeOpacity='0.12'
            strokeLinecap='round'
        />
        <path
            fillRule='evenodd'
            clipRule='evenodd'
            d='M92.0013 57.3883H113.118C114.095 57.3883 114.885 58.1742 114.885 59.1484V66.9186C114.885 73.5528 111.909 78.9321 105.259 78.9321H99.8606C93.2109 78.9321 90.2349 73.5528 90.2349 66.9186V59.1484C90.2349 58.1775 91.0273 57.3883 92.0013 57.3883ZM102.172 61.9248H101.235V64.127V68.0017L102.478 69.2449L101.235 70.4881V72.1297H104.636V65.3642L103.686 64.4136L104.636 63.4629V61.9248H102.172Z'
            fill='#1C58D9'
        />
        <path
            fillRule='evenodd'
            clipRule='evenodd'
            d='M108.374 54.1074V57.4273C108.374 57.4476 108.375 57.4675 108.376 57.4871H111.35C111.352 57.4675 111.352 57.4476 111.352 57.4273V54.1074C111.352 49.1351 108.096 45.0882 103.308 45.0882H101.28C96.4909 45.0882 93.2349 49.1351 93.2349 54.1074V57.4273C93.2349 57.4476 93.2356 57.4675 93.2371 57.4871H96.205C96.2066 57.4675 96.2073 57.4476 96.2073 57.4273V54.1074C96.2073 50.7242 98.3244 48.1476 100.835 48.1476H103.746C106.424 48.1476 108.374 50.7242 108.374 54.1074Z'
            fill='#1C58D9'
        />
        <path
            d='M109 16C109 16 118.172 25.6296 137 29'
            stroke='#3F4350'
            strokeLinecap='round'
            strokeLinejoin='round'
        />
        <rect
            x='1.5'
            y='20.5'
            width='43'
            height='79'
            rx='7.5'
            fill='white'
            stroke='#3F4350'
            strokeWidth='3'
        />
        <path
            d='M3 27.5C3 24.4624 5.46243 22 8.5 22H37.5C40.5376 22 43 24.4624 43 27.5V29H3V27.5Z'
            fill='#1C58D9'
            fillOpacity='0.16'
        />
        <circle
            cx='12.831'
            cy='64.831'
            r='5.83099'
            fill='#3F4350'
            fillOpacity='0.32'
        />
        <path
            d='M9.69995 64.7411L12.0947 67.1786L16.2 63'
            stroke='white'
            strokeWidth='0.5525'
            strokeLinecap='round'
            strokeLinejoin='round'
        />
        <path
            d='M22.5488 63H32.915'
            stroke='#3F4350'
            strokeOpacity='0.48'
            strokeLinecap='round'
        />
        <path
            d='M8 74H34'
            stroke='#3F4350'
            strokeOpacity='0.48'
            strokeLinecap='round'
        />
        <path
            d='M8 82H28'
            stroke='#3F4350'
            strokeOpacity='0.48'
            strokeLinecap='round'
        />
        <path
            d='M22.5488 67H38.746'
            stroke='#3F4350'
            strokeOpacity='0.48'
            strokeLinecap='round'
        />
        <path
            d='M8 78H24'
            stroke='#3F4350'
            strokeOpacity='0.48'
            strokeLinecap='round'
        />
        <path
            d='M27 78L39 78'
            stroke='#3F4350'
            strokeOpacity='0.48'
            strokeLinecap='round'
        />
        <rect
            x='15'
            y='25'
            width='16'
            height='1'
            rx='0.5'
            fill='#3F4350'
        />
        <rect
            opacity='0.16'
            x='157'
            y='23'
            width='49'
            height='64'
            rx='4'
            fill='#090A0B'
        />
        <rect
            x='159.5'
            y='19.5'
            width='48'
            height='65'
            rx='3.5'
            fill='white'
            stroke='#3F4350'
        />
        <path
            d='M185 38H201'
            stroke='#3F4350'
            strokeOpacity='0.56'
            strokeLinecap='round'
        />
        <path
            d='M184 65H200'
            stroke='#3F4350'
            strokeOpacity='0.56'
            strokeLinecap='round'
        />
        <path
            d='M184 71H200'
            stroke='#3F4350'
            strokeOpacity='0.56'
            strokeLinecap='round'
        />
        <path
            d='M165 47H202'
            stroke='#3F4350'
            strokeOpacity='0.56'
            strokeLinecap='round'
        />
        <path
            d='M165 53H202'
            stroke='#3F4350'
            strokeOpacity='0.56'
            strokeLinecap='round'
        />
        <path
            d='M185 32H194.635'
            stroke='#3F4350'
            strokeOpacity='0.56'
            strokeLinecap='round'
        />
        <path
            d='M196.932 32H199.946'
            stroke='#3F4350'
            strokeOpacity='0.56'
            strokeLinecap='round'
        />
        <path
            fillRule='evenodd'
            clipRule='evenodd'
            d='M171.467 26.918H173.457L173.709 28.5555C174.318 28.6939 174.888 28.9343 175.401 29.2577L176.74 28.2756L178.147 29.6827L177.153 31.0376C177.462 31.545 177.691 32.1069 177.822 32.7055L179.505 32.9645V34.9544L177.778 35.2201C177.634 35.7869 177.401 36.3184 177.094 36.7986L178.147 38.2337L176.74 39.6407L175.271 38.5634C174.801 38.8416 174.286 39.0514 173.74 39.179L173.46 41H171.47L171.188 39.1638C170.651 39.0316 170.145 38.8198 169.684 38.5418L168.186 39.6406L166.779 38.2335L167.867 36.7505C167.577 36.2856 167.355 35.774 167.215 35.2294L165.422 34.9535V32.9636L167.172 32.6944C167.299 32.1186 167.516 31.577 167.809 31.0854L166.78 29.6826L168.187 28.2755L169.556 29.2795C170.058 28.9575 170.616 28.7157 171.213 28.5718L171.467 26.918ZM175.147 33.8704C175.147 35.335 173.96 36.5222 172.495 36.5222C171.031 36.5222 169.844 35.335 169.844 33.8704C169.844 32.4059 171.031 31.2187 172.495 31.2187C173.96 31.2187 175.147 32.4059 175.147 33.8704Z'
            fill='#3F4350'
            fillOpacity='0.56'
        />
        <path
            opacity='0.7'
            fillRule='evenodd'
            clipRule='evenodd'
            d='M172.405 61.9492H174.038L174.244 63.2907C174.745 63.4044 175.213 63.602 175.635 63.8679L176.73 63.0643L177.885 64.2188L177.071 65.3279C177.325 65.744 177.513 66.2048 177.619 66.6957L179 66.9081V68.5407L177.584 68.7585C177.465 69.2245 177.274 69.6613 177.022 70.0558L177.885 71.2329L176.73 72.3874L175.525 71.5032C175.14 71.7307 174.719 71.9023 174.272 72.0069L174.042 73.5039H172.409L172.177 71.9948C171.737 71.8867 171.324 71.7135 170.946 71.4861L169.715 72.3888L168.561 71.2344L169.453 70.0171C169.215 69.6355 169.033 69.2155 168.918 68.7683L167.445 68.5418V66.9092L168.881 66.6882C168.985 66.2163 169.163 65.7723 169.403 65.3692L168.56 64.2202L169.715 63.0657L170.835 63.887C171.247 63.6218 171.706 63.4226 172.197 63.3043L172.405 61.9492ZM175.426 67.6523C175.426 68.8539 174.452 69.828 173.25 69.828C172.048 69.828 171.074 68.8539 171.074 67.6523C171.074 66.4507 172.048 65.4766 173.25 65.4766C174.452 65.4766 175.426 66.4507 175.426 67.6523Z'
            fill='#3F4350'
            fillOpacity='0.56'
        />
    </svg>
);

export default MobileSecuritySVG;
